<template>
  <div>
    <div id="routelist_filter">
      <TableActionHeader @filterChange="(val) => {this.filter = val}" :newButton=false></TableActionHeader>
    </div>
        <b-table hover striped :items="listData" :fields="fields"
            :responsive="false"
            :small="true"
            primary-key="tunnus"
            ref="routeList"
            selectable selection-mode="multi"
            @row-selected="onRowSelected"
            :filter="filter"
            :filterIncludedFields="filterOn"
            :per-page="pagingPerPage"
            :current-page="currentPage"
            >
            <template v-slot:cell(tunnus)="data">
               <span>{{ data.value }}</span>
            </template>
            <template v-slot:cell(linja)="data">
                {{data.item.linja}}
            </template>
            <template v-slot:cell(nimi)="data">
                <span class="listNameText"><p class="listNameParag">{{ data.item.linja }}</p></span>
                <span class="listLabelText">{{ data.item.nimi }}</span>
            </template>
            <template v-slot:cell(organisaatio)="data">
                {{ data.item.organisaatio }}
            </template>
        </b-table>
        <div class="d-flex justify-content-center">
          <TablePagination :perPage="pagingPerPage" :totalRows="listLength" @pageChange="(p)=>{this.currentPage = p}"></TablePagination>
       </div>
  </div>
</template>

<script>
import timetable from '@/store/timetable/timetable'

export default {
  name: 'RouteList',
  props: {
   // msg: String
  },
  data: function() {
        return {
            fields: [ 
            {key:'tunnus',label:'Id', sortable: true },
            {key:"nimi",label:"Name", sortable: true },
            {key:"organisaatio",label:"Organization", sortable: true },
            ],
            currentPage: 1,
            selected: [],
            pagingPerPage: 5,
            filter: null,
            filterOn: ['tunnus','linja','nimi','organisaatio']
        }
  },
  beforeCreate: function() {
    if (!this.$store.state.timetable) {
      this.$store.registerModule("timetable" , timetable);
    }
  },
  created: function() {
  },
  mounted: function() {
     if(!this.listData || this.listData.length === 0) {
       this.$store.dispatch('timetable/getRoutesListData')
       .catch(function(){
       });
     }
    this.deselectAll();
  },
  computed: {
    listData: function() {
      return this.$store.state.timetable.routes.list;
    },
    listLength: function() {
      if(Array.isArray(this.listData)) {
        return this.listData.length;
      } else {
        return 0;
      }
    }
  },
  watch: {
  },
  methods: {
    onRowSelected(items) {
      this.selected = items
    },
    deselectAll() {
      this.$refs.routeList.clearSelected();
      this.selected = [];
    },
    getSelectedList() {
      return JSON.parse(JSON.stringify(this.selected));
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
p {
  margin-bottom: 0.1rem;
}
p .listNameParag {
  margin-bottom: 0.1rem;
}
.listNameText {
  font-weight: bold;
}
.listLabelText {
  font-style: italic;
  padding-left: 1em;
}
</style>
